export const SITES_COLLECTION = 'sites';
export const ITEMS_COLLECTION = 'items';
export const USERS_COLLECTION = 'users';
